import EdverumTable from '@/store/utilities/EdverumTable.js';

const collectionHelpers = EdverumTable.collection('courseTemplate');

export default {
    state: {
        ...EdverumTable.search.state,
        ...EdverumTable.searchTag.state,
        ...EdverumTable.searchGroup.state,
        ...EdverumTable.searchCourseCode.state,
        ...EdverumTable.viewArchived.state,
    },

    getters: {
        ...EdverumTable.search.getters,
        ...EdverumTable.searchTag.getters,
        ...EdverumTable.searchGroup.getters,
        ...EdverumTable.searchCourseCode.getters,
        ...EdverumTable.viewArchived.getters,
    },

    actions: {
        fetchAssignableTags: EdverumTable.searchTag.actions.fetchAssignableTags(
            '/api/tags?type=course_template&model=CourseTemplate'
        ),
        fetchAssignableCourseCodes: collectionHelpers.actions.fetchAssignableCourseCodes(),
        reset: collectionHelpers.actions.reset('CourseTemplatesView'),
        clearSort: collectionHelpers.actions.clearSort,
        fetchAssignableGroups: collectionHelpers.actions.fetchAssignableGroups(),
    },

    mutations: {
        ...EdverumTable.search.mutations,
        ...EdverumTable.searchTag.mutations,
        ...EdverumTable.searchGroup.mutations,
        ...EdverumTable.searchCourseCode.mutations,
        SET_ASSIGNABLE_GROUPS: collectionHelpers.mutations.SET_ASSIGNABLE_GROUPS,

        CLEAR_SORTING() {
            // Method called from EdverumTable.actions.reset()
        },
    },
};
